import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../../../hooks/useAxiosClient";
import { TRootState } from "../../../store";
import * as XLSX from "xlsx";
import useGetBankPartnersData from "../useGetbankPartners";
import {
  setMarketAddEditVal,
  setMarketImages,
  setMarketUpdated,
  setOpenMarketAddPanel,
  setRefreshAllMarketsEntity,
  setRefreshMarketByIdEntity,
  udpateAddMarketData,
} from "../../../reducers/marketSlice";
import { TCrop, TCropOption } from "../../../types";
import { TMandiBankSofwarePartners, TMarketImgs } from "../../../types/markets";
import { toast } from "react-toastify";
import moment from "moment";
import active from "../../../assets/images/approveTick.svg";
import inactive from "../../../assets/images/inactive.svg";
import { add } from "lodash";
interface Holiday {
  date: string;
  event: string;
  status?: number;
  id?: number;
}
const useAddMarket = () => {
  const { handlePostCall, handlePutCall } = useAxiosClient();
  const {
    adminId,
    marketDetailsEditStatus,
    mandiEmployeesData,
    addMarketDetails,
    bankPartnersData,
    softwarePartnersData,
    marketImages,
  } = useSelector((state: TRootState) => ({
    adminId: state.auth.adminId,
    dateRange: state.marketDetails.dateRange,
    openMarketDetailsPanel: state.marketDetails.openMarketDetailsPanel,
    marketAddPanel: state.marketDetails.marketAddPanel,
    marketDetailsEditStatus: state.marketDetails.marketDetailsEditStatus,
    mandiEmployeesData: state.marketDetails.mandiEmployeesData,
    addMarketDetails: state.marketDetails.addMarketDetails,
    bankPartnersData: state.marketDetails.bankPartnersData,
    softwarePartnersData: state.marketDetails.softwarePartnersData,
    marketImages: state.marketDetails.marketImages,
  }));
  const dispatch = useDispatch();
  const daysList = ["S", "M", "T", "W", "T", "F", "S"];
  const fullDayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  interface AuctionTime {
    from: string;
    to: string;
    id?: number;
    status?: number;
  }

  interface DaySchedule {
    workingHours: AuctionTime;
    auctions: AuctionTime[];
    enabled: boolean;
    workingId?: number;
    workingStatus?: number;
  }

  //   get employye and bank partners dropdown dataa
  const {
    getMandiEmployeesData,
    getMandiSoftwarePartners,
    getMandiBankPartners,
  } = useGetBankPartnersData();
  useEffect(() => {
    getMandiEmployeesData();
    getMandiSoftwarePartners();
    getMandiBankPartners();
  }, []);
  // set address data
  const [address, setAddress] = useState({
    pincode: addMarketDetails?.address?.pincode
      ? addMarketDetails?.address?.pincode
      : "",
    state: addMarketDetails?.address?.state || "",
    district: addMarketDetails?.address?.city || "",
    village: addMarketDetails?.address?.addressLine || "",
  });

  // update default status from get api
  useEffect(() => {
    if (marketDetailsEditStatus) {
      if (addMarketDetails?.status == 0 || addMarketDetails?.status == 1) {
        onUpdateAddMarketInput(
          "MARKETSTATUS",
          addMarketDetails?.status === 1 ? "ACTIVE" : "INACTIVE"
        );
      }
      if (addMarketDetails?.apmcStatus) {
        onUpdateAddMarketInput("OFFICENAME", addMarketDetails?.apmcStatus);
      }
    }
  }, [marketDetailsEditStatus, addMarketDetails?.status]);

  // set softwares selected
  const [selectedSoftwares, setSelectedSoftwares] = useState<
    TMandiBankSofwarePartners[]
  >(
    addMarketDetails?.softwares?.map((s) => ({
      ...s,
      label: s.name,
      status: 2,
      value: s.name.toLowerCase().replace(/\s+/g, ""),
    })) || []
  );
  // set bannaks selected
  const [selectedBanks, setSelectedBanks] = useState<
    TMandiBankSofwarePartners[]
  >(
    addMarketDetails?.bankPartners?.map((s) => ({
      ...s,
      label: s.name,
      status: 2,
      value: s.name.toLowerCase().replace(/\s+/g, ""),
    })) || []
  );
  const [mandiHeadDropdown, setMandiHeadDropdown] = useState(false);
  // get all dropdown options and set to sttes
  const softwareOptions = softwarePartnersData?.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.name.toLowerCase().replace(/\s+/g, ""),
    mobile: "",
    type: "",
    profilePic: "",
    address: "",
  }));
  const bankOptions = bankPartnersData?.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.name.toLowerCase().replace(/\s+/g, ""),
    mobile: "",
    type: "",
    profilePic: "",
    address: "",
  }));
  // all static dropdown
  const licenceTypeDropdownOptions = [
    { value: "APMC", label: "APMC" },
    { value: "PRIVATE", label: "PRIVATE" },
    { value: "STATE MANAGED", label: "STATE MANAGED" },
  ];
  const martketStatusOptions = [
    { value: "ACTIVE", label: "ACTIVE", icon: active },
    { value: "INACTIVE", label: "INACTIVE", icon: inactive },
  ];
  const employeeCountDropdownOptions = [
    { value: "1-5", label: "1-5" },
    { value: "6-10", label: "6-10" },
    { value: "10+", label: "10+" },
  ];

  // all static dropdown handle events
  const handleLicenceDropdownChange = (value: any) => {
    onUpdateAddMarketInput("LICENCE", value);
  };
  const handleMarketStatusDropdownChange = (value: any) => {
    onUpdateAddMarketInput("MARKETSTATUS", value);
  };
  const handleEmpCountDropdownChange = (value: any) => {
    onUpdateAddMarketInput("EMPLCOUNT", value);
  };

  // add market field values update heere
  const onUpdateAddMarketInput = (type: string, value: any) => {
    let addMarkData = addMarketDetails;
    if (type === "MARKETNAME") {
      addMarkData = {
        ...addMarkData,
        marketName: value,
      };
    } else if (type === "LONGITUDE") {
      addMarkData = {
        ...addMarkData,
        address: {
          ...addMarkData.address,
          longitude: value,
        },
      };
    } else if (type === "LATITUDE") {
      addMarkData = {
        ...addMarkData,
        address: {
          ...addMarkData.address,
          latitude: value,
        },
      };
    } else if (type === "MANDITYPE") {
      addMarkData = {
        ...addMarkData,
        marketType: value,
      };
    } else if (type === "MANDISIZE") {
      addMarkData = {
        ...addMarkData,
        marketSize: value,
      };
    } else if (type === "OFFICENAME") {
      addMarkData = {
        ...addMarkData,
        apmcStatus: value,
      };
    } else if (type === "OFCHEAD") {
      addMarkData = {
        ...addMarkData,
        headName: value,
      };
    } else if (type === "LICENCE") {
      addMarkData = {
        ...addMarkData,
        licenceType: value,
      };
    } else if (type === "MARKETSTATUS") {
      addMarkData = {
        ...addMarkData,
        status: value,
      };
    } else if (type === "EMPLCOUNT") {
      addMarkData = {
        ...addMarkData,
        empCount: value,
      };
    } else if (type === "ONOID") {
      addMarkData = {
        ...addMarkData,
        employee: {
          ...addMarkData.employee,
          onoId: value?.onoId,
          mobile: value?.mobile,
          name: value?.name,
          profilePic: value?.profilePic,
        },
      };
    } else if (type === "RMORS") {
      addMarkData = {
        ...addMarkData,
        rmOrs: value,
      };
    } else if (type === "MARKETORC") {
      addMarkData = {
        ...addMarkData,
        marketOrs: value,
      };
    } else if (type === "NO.OFSHOPS") {
      addMarkData = {
        ...addMarkData,
        shopCount: value,
      };
    }
    dispatch(
      udpateAddMarketData({
        addMarketData: addMarkData,
      })
    );
  };

  // all crop data here
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedCrops, setSelectedCrops] = useState<TCropOption[]>(
    (addMarketDetails?.crops || []).map((c) => ({ ...c, status: 2 }))
  );
  // updated
  const addCropItem = (newCrops: TCropOption[]) => {
    const incomingCropIds = new Set(newCrops.map((c) => c.cropId));

    let updated = selectedCrops
      .map((item) => {
        const isStillSelected = incomingCropIds.has(item.cropId);

        if (!isStillSelected) {
          if (item.id) {
            return { ...item, status: 0 };
          }
          return null;
        }
        return item;
      })
      .filter((item): item is TCropOption => item !== null);
    newCrops.forEach((crop) => {
      const exists = updated.find((c) => c.cropId === crop.cropId);

      if (exists) {
        if (exists.status === 0) {
          updated = updated.map((c) =>
            c.cropId === exists.cropId ? { ...c, status: 2 } : c
          );
        }
      } else {
        updated.push({ ...crop, status: 1 });
      }
    });

    setSelectedCrops(updated);
    dispatch(
      udpateAddMarketData({
        addMarketData: { ...addMarketDetails, crops: updated },
      })
    );
  };
  const removeCropItem = (cropId: number) => {
    const updated: TCropOption[] = selectedCrops
      .map((c) => {
        if (c.cropId === cropId) {
          if (c.status === 1) {
            return null;
          } else if (c.status === 2) {
            return { ...c, status: 0 };
          }
        }
        return c;
      })
      .filter(Boolean) as TCrop[];

    setSelectedCrops(updated);
    dispatch(
      udpateAddMarketData({
        addMarketData: { ...addMarketDetails, crops: updated },
      })
    );
  };
  // currently not usings
  const [otherSoftwareInput, setOtherSoftwareInput] = useState("");
  const [softwares, setSoftwares] = useState<string[]>([]);

  const handleAddSoftware = () => {
    if (
      otherSoftwareInput.trim() &&
      !softwares.includes(otherSoftwareInput.trim())
    ) {
      setSoftwares([...softwares, otherSoftwareInput.trim()]);
      setOtherSoftwareInput("");
    }
  };

  const handleRemoveSoftware = (name: string) => {
    setSoftwares(softwares.filter((s) => s !== name));
  };

  // add months holidys data
  const [holidays, setHolidays] = useState<Holiday[]>(
    addMarketDetails?.holidays?.map((h) => ({
      date: h.date,
      event: h.eventName,
      status: 2,
      id: h.id,
    })) || []
  );

  const handleImportHolidaylist = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileInput = e.target;
    const file = fileInput.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = evt.target?.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json<Record<string, any>>(sheet);

      if (!jsonData.length) {
        toast.error(" Uploaded file is empty or not readable.", {
          toastId: `empty-${Date.now()}`,
        });
        fileInput.value = "";
        return;
      }

      const sampleRow = jsonData[0];
      const headers = Object.keys(sampleRow).map((key) =>
        key.replace(/\s+/g, " ").trim().toLowerCase()
      );

      const hasDateHeader = headers.some((h) => h.includes("date"));
      const hasEventHeader = headers.some(
        (h) => h.includes("event") || h === "name" || h.includes("holiday")
      );

      if (!hasDateHeader || !hasEventHeader) {
        toast.error(
          `Invalid headers found. Please upload Excel with correct header names (like "Date" and "Event Name / Name / Holiday").`,
          { toastId: `invalid-header-${Date.now()}` }
        );
        fileInput.value = "";
        return;
      }

      const acceptedFormats = ["YYYY-MM-DD", "DD-MM-YYYY", "DD-MMM-YYYY"];
      let invalidRows: string[] = [];

      const imported = jsonData
        .map((row, index): Holiday | null => {
          const normalizedRow: Record<string, any> = {};
          Object.keys(row).forEach((key) => {
            const cleanKey = key.replace(/\s+/g, " ").trim();
            normalizedRow[cleanKey] = row[key];
          });

          let dateValue = normalizedRow["Date"];
          let formattedDate = "";

          if (typeof dateValue === "number") {
            const excelEpoch = new Date(1899, 11, 30);
            const jsDate = new Date(
              excelEpoch.getTime() + dateValue * 24 * 60 * 60 * 1000
            );
            formattedDate = moment(jsDate).format("YYYY-MM-DD");
          } else if (typeof dateValue === "string") {
            const m = moment(dateValue, acceptedFormats, true);
            if (m.isValid()) {
              formattedDate = m.format("YYYY-MM-DD");
            } else {
              invalidRows.push(`Row ${index + 2}: Invalid date → ${dateValue}`);
            }
          } else {
            invalidRows.push(`Row ${index + 2}: Missing or invalid date`);
          }

          const eventHeader = Object.keys(normalizedRow).find((k) =>
            /(event|name|holiday)/i.test(k)
          );
          const eventName = eventHeader ? normalizedRow[eventHeader] : "";

          if (!formattedDate || !eventName) return null;

          return {
            date: formattedDate,
            event: eventName || "",
            status: 1,
          };
        })
        .filter((row): row is Holiday => row !== null);

      if (invalidRows.length > 0) {
        toast.error(`Some dates are invalid or in the wrong format.`, {
          toastId: `invalid-dates-${Date.now()}`,
        });
        fileInput.value = "";
        return;
      }

      setHolidays((prev) => [...prev, ...imported]);
      fileInput.value = "";
    };

    reader.readAsBinaryString(file);
  };

  const handleHolidaysAdd = () => {
    setHolidays((prev) => [
      ...prev,
      { id: undefined, date: "", event: "", status: 1 },
    ]);
  };

  const handleDeleteHoliday = (index: number) => {
    setHolidays((prev) => {
      const updated = [...prev];
      const holiday = updated[index];

      if (holiday.id) {
        holiday.status = 0;
      } else {
        updated.splice(index, 1);
      }

      return updated;
    });
  };

  const handleChangeHoliday = (
    index: number,
    key: keyof Omit<Holiday, "status" | "id">,
    value: string
  ) => {
    setHolidays((prev) => {
      const updated = [...prev];
      const holiday = { ...updated[index] };

      holiday[key] = value;

      if (holiday.id && holiday.status !== 1) {
        holiday.status = 2;
      }

      updated[index] = holiday;
      return updated;
    });
  };
  // upload images
  const onUploadImage = async (type: "MARKETS", file: FileList | File[]) => {
    const uploadPromises = Array.from(file).map(async (file) => {
      let fileType: "pdf" | "image" | "video";
      if (file.type === "application/pdf") {
        fileType = "pdf";
      } else if (file.type.includes("image/")) {
        fileType = "image";
      } else if (file.type.startsWith("video/")) {
        fileType = "video";
      } else {
        return;
      }

      let formdata = new FormData();
      formdata.append("file", file, file.name.replace(" ", "-"));
      formdata.append("id", `${adminId}`);
      formdata.append("type", "MARKETS");

      let imageUploadResponse = await handlePostCall<string[]>({
        URL: "mandi/files/markets/imgs/upload",
        apiParams: formdata,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      });

      const url = imageUploadResponse.data[0];

      const newDocument: TMarketImgs = {
        id: 0,
        status: 1,
        type: "MARKETS",
        url,
      };

      if (type === "MARKETS") {
        const updatedTapal: TMarketImgs[] = [...marketImages, newDocument];
        dispatch(setMarketImages(updatedTapal));
      }
    });

    await Promise.all(uploadPromises);
  };
  const onRemoveImage = (
    imageUrl: string,
    isExisting: boolean = false,
    imageId?: number
  ) => {
    if (isExisting) {
      const updatedImages = marketImages.map((img) =>
        img.id === imageId ? { ...img, status: 0 } : img
      );
      dispatch(setMarketImages(updatedImages));
    } else {
      const updatedNewImages = marketImages.filter(
        (img) => img.url !== imageUrl
      );
      dispatch(setMarketImages(updatedNewImages));
    }
  };
  // update default images
  useEffect(() => {
    if (addMarketDetails?.marketImgs?.length > 0) {
      const imagesWithStatus = addMarketDetails.marketImgs.map((img) => ({
        ...img,
        status: 2,
      }));
      dispatch(setMarketImages(imagesWithStatus));
    }
  }, [addMarketDetails?.marketImgs]);

  // set market hours data
  const [schedules, setSchedules] = useState<
    Record<number, DaySchedule & { dayName: string }>
  >(
    Object.fromEntries(
      daysList.map((dayName, i) => [
        i,
        {
          dayName: fullDayNames[i],
          workingHours: { from: "", to: "" },
          auctions: [],
          enabled: true,
          workingId: 0,
          workingStatus: 1,
        },
      ])
    )
  );
  const [backupSchedules, setBackupSchedules] = useState<Record<
    number,
    DaySchedule
  > | null>(null);
  const [showRevert, setShowRevert] = useState(false);

  // update markets ops form get api
  useEffect(() => {
    if (!addMarketDetails?.marketOps?.length) return;

    const apiSchedules = addMarketDetails.marketOps;

    const updatedSchedules = Object.fromEntries(
      daysList.map((_, i) => {
        const fullDay = fullDayNames[i];
        const daySchedules = apiSchedules.filter(
          (s) => s.day.toLowerCase() === fullDay.toLowerCase()
        );

        const working = daySchedules.find((s) => s.type === "WORKING");
        const auctions = daySchedules
          .filter((s) => s.type === "AUCTION")
          .map((a) => ({
            id: a.id || 0,
            from: a.startTime || "",
            to: a.endTime || "",
            status: 2,
          }));

        return [
          i,
          {
            dayName: fullDay,
            workingHours: {
              from: working?.startTime || "",
              to: working?.endTime || "",
            },
            workingId: working?.id || 0,
            workingStatus: working ? 2 : 1,
            auctions,
            enabled: working?.marketStatus ?? true,
          },
        ];
      })
    );

    setSchedules(updatedSchedules);

    setBackupSchedules(JSON.parse(JSON.stringify(updatedSchedules)));
  }, [addMarketDetails?.marketOps]);

  const [activeDay, setActiveDay] = useState(1);

  const handleDeleteAuction = (dayIndex: number, index: number) => {
    setSchedules((prev) => {
      const updated = { ...prev };
      const currentDay = JSON.parse(JSON.stringify(updated[dayIndex]));
      const auction = currentDay.auctions[index];

      if (auction.id > 0) {
        auction.status = 0;
        currentDay.auctions[index] = auction;
      } else {
        currentDay.auctions.splice(index, 1);
      }

      updated[dayIndex] = currentDay;
      return updated;
    });
  };

  const handleToggleDay = (dayIndex: number) => {
    setSchedules((prev) => ({
      ...prev,
      [dayIndex]: {
        ...prev[dayIndex],
        enabled: !prev[dayIndex].enabled,
      },
    }));
  };

  const handleSelectOption = (
    value: string,
    dayIndex: number,
    type: "working" | "auction",
    index: number | null,
    key: keyof AuctionTime
  ) => {
    setSchedules((prev) => {
      const updated = { ...prev };
      const currentDay = JSON.parse(JSON.stringify(updated[dayIndex]));

      if (type === "working") {
        currentDay.workingHours[key] = value;
        if (currentDay.workingId > 0) currentDay.workingStatus = 2;
      } else if (type === "auction" && index !== null) {
        const auction = currentDay.auctions[index];
        auction[key] = value;
        if (auction.id > 0) auction.status = 2;
      }

      updated[dayIndex] = currentDay;
      return updated;
    });
  };

  const handleAddAuction = (dayIndex: number) => {
    setSchedules((prev) => {
      const updated = { ...prev };
      const currentDay = JSON.parse(JSON.stringify(updated[dayIndex]));
      currentDay.auctions.push({
        id: 0,
        from: "",
        to: "",
        status: 1,
      });
      updated[dayIndex] = currentDay;
      return updated;
    });
  };

  const applyToAllDays = () => {
    setSchedules((prev) => {
      // const backup = JSON.parse(JSON.stringify(prev));
      // setBackupSchedules(backup);
      // setBackupSchedules(structuredClone(schedules));

      const updated = JSON.parse(JSON.stringify(prev));
      const sourceDay = updated[activeDay];

      daysList.forEach((_, i) => {
        const targetDay = updated[i];
        if (!targetDay.enabled || i === activeDay) return; // skip source day

        const newWorkingStatus =
          targetDay.workingId && targetDay.workingId > 0 ? 2 : 1;

        const newAuctions = sourceDay.auctions.map(
          (srcAuction: any, index: number) => {
            const existingAuction = targetDay.auctions[index];

            if (existingAuction) {
              return {
                ...existingAuction,
                from: srcAuction.from,
                to: srcAuction.to,
                status:
                  srcAuction.status === 0 ? 0 : existingAuction.id > 0 ? 2 : 1,
              };
            } else {
              return {
                id: 0,
                from: srcAuction.from,
                to: srcAuction.to,
                status: srcAuction.status === 0 ? 0 : 1,
              };
            }
          }
        );

        if (targetDay.auctions.length > newAuctions.length) {
          newAuctions.push(...targetDay.auctions.slice(newAuctions.length));
        }

        updated[i] = {
          ...targetDay,
          auctions: newAuctions,
          workingHours: { ...sourceDay.workingHours },
          workingStatus: newWorkingStatus,
        };
      });

      setShowRevert(true);

      return updated;
    });
  };

  const revertAllDays = () => {
    setSchedules((prev) => {
      if (marketDetailsEditStatus && backupSchedules) {
        return JSON.parse(JSON.stringify(backupSchedules));
      } else {
        const cleared = { ...prev };
        daysList.forEach((_, i) => {
          cleared[i] = {
            ...cleared[i],
            workingHours: { from: "", to: "" },
            auctions: [],
            workingStatus: 0,
          };
        });
        return cleared;
      }
    });

    // setBackupSchedules(null);
    setShowRevert(false);
  };

  const onSaveMarketData = () => {
    const images = [];
    if (validateAddEditMarket()) {
      //   setLoading(true);
      for (let file of marketImages) {
        if (file.type === "MARKETS") {
          images.push({
            id: 0,
            reqId: 0,
            status: 1,
            addedBy: adminId || 0,
            type: file.type,
            url: file.url,
          });
        }
      }
      const marketOps = Object.entries(schedules).flatMap(([key, day]) => {
        const results = [];

        if (day.workingHours?.from && day.workingHours?.to) {
          results.push({
            day: day.dayName,
            startTime: day.workingHours.from,
            endTime: day.workingHours.to,
            id: 0,
            marketId: 0,
            status: 1,
            type: "WORKING",
            marketStatus: day.enabled,
          });
        }
        if (Array.isArray(day.auctions) && day.auctions.length > 0) {
          day.auctions.forEach((auction) => {
            results.push({
              day: day.dayName,
              startTime: auction.from || "",
              endTime: auction.to || "",
              id: 0,
              marketId: 0,
              status: 1,
              type: "AUCTION",
              marketStatus: day.enabled,
            });
          });
        }
        if (!day.enabled) {
          results.push({
            day: day.dayName,
            startTime: "",
            endTime: "",
            id: 0,
            marketId: 0,
            status: 1,
            type: "WORKING",
            marketStatus: day.enabled,
          });
        }

        return results;
      });
      const updatedHolidays = holidays
        .filter((day) => day.date && day.date.trim() !== "")
        .map((day) => ({
          date: day.date,
          eventName: day.event,
          id: 0,
          marketId: 0,
          status: 1,
        }));

      const hasEmptyEvent = updatedHolidays.some(
        (h) =>
          h.status !== 0 &&
          h.date &&
          (!h.eventName || h.eventName.trim() === "")
      );

      if (hasEmptyEvent) {
        toast.error("Please enter an event name for all selected dates.");
        return;
      }
      const obj = {
        address: {
          addressLine: address?.village,
          city: address?.district,
          dist: address?.village,
          latitude: addMarketDetails?.address.latitude,
          longitude: addMarketDetails?.address.longitude,
          marketId: "",
          pincode: address.pincode,
          state: address?.state,
          traderId: 0,
        },
        adminId: adminId,
        apmcStatus: addMarketDetails?.apmcStatus,
        bankPartners: selectedBanks.map((bank, i) => {
          return {
            id: bank.id,
            marketId: 0,
            name: bank.label,
            type: "BANK",
            sid: bank.sid,
          };
        }),
        caCount: addMarketDetails?.caCount,
        crops: selectedCrops,
        empCount: addMarketDetails?.empCount,
        headName: addMarketDetails?.headName,
        holidays: updatedHolidays,
        licenceType: addMarketDetails?.licenceType,
        maketKnownFor: addMarketDetails?.maketKnownFor,
        marketId: "",
        marketImgs: images,
        marketName: addMarketDetails?.marketName,
        marketOpDays: addMarketDetails?.marketOpDays,
        marketOps: marketOps,
        marketOrs: addMarketDetails?.marketOrs,
        marketSize: addMarketDetails?.marketSize,
        marketType: addMarketDetails?.marketType,
        shopCount: Number(addMarketDetails?.shopCount),
        mid: 0,
        noofBuyers: 0,
        onoId: addMarketDetails?.employee?.onoId,
        peakHours: addMarketDetails?.peakHours,
        rmOrs: addMarketDetails?.rmOrs,
        softwares: selectedSoftwares.map((soft, i) => {
          return {
            id: soft.id,
            marketId: 0,
            name: soft.label,
            type: "SOFTWARE",
            sid: soft.sid,
          };
        }),
        status: addMarketDetails?.status == "ACTIVE" ? 1 : 0,
        traderCount: addMarketDetails?.traderCount,
        transCount: addMarketDetails?.transCount,
      };

      handlePostCall({
        URL: "admin/markets/mpower",
        apiParams: obj,
      })
        .then(({ data, status }) => {
          toast.success(status.description);
          dispatch(setOpenMarketAddPanel(false));
          dispatch(setRefreshAllMarketsEntity());
        })
        .catch((err: any) => {
          // toast.error(err.response.data.status.description);
        });
    }
  };
  const onUpdateMarketData = () => {
    if (validateAddEditMarket()) {
      //   setLoading(true);
      const images = marketImages
        .filter((img) => img.status === 1 || img.status === 0)
        .map((img) => ({
          id: img.id || 0,
          reqId: img.id || 0,
          status: img.status,
          addedBy: adminId || 0,
          type: img.type,
          url: img.url,
        }));

      if (images.length > 0 && images.every((img) => img.status === 0)) {
        toast.error("Please upload atleast one mandi image .");
        return;
      }
      const marketOps = Object.entries(schedules).flatMap(([key, day]) => {
        const results: any[] = [];

        // working hours
        results.push({
          day: day.dayName,
          startTime: day.workingHours.from || "",
          endTime: day.workingHours.to || "",
          id: day.workingId || 0,
          marketId: "",
          status: day.workingStatus,
          type: "WORKING",
          marketStatus: day.enabled,
        });

        // auctions
        day.auctions.forEach((auction: any) => {
          results.push({
            day: day.dayName,
            startTime: auction.from || "",
            endTime: auction.to || "",
            id: auction.id || 0,
            marketId: "",
            status: auction.status,
            type: "AUCTION",
            marketStatus: day.enabled,
          });
        });

        return results;
      });

      const updatedHolidays = holidays
        .filter((day) => day.date && day.date.trim() !== "")
        .map((h) => ({
          id: h.id || 0,
          date: h.date,
          eventName: h.event,
          status: h.status,
        }));
      const hasEmptyEvent = updatedHolidays.some(
        (h) =>
          h.status !== 0 &&
          h.date &&
          (!h.eventName || h.eventName.trim() === "")
      );

      if (hasEmptyEvent) {
        toast.error("Please enter an event name for all selected dates.");
        return;
      }
      const updatedSoftwares = selectedSoftwares
        .filter((s) => s.status !== 2)
        .map((s) => ({
          id: s.id,
          name: s.label,
          status: s.status,
          type: s.type || "SOFTWARE",
          sid: s.sid,
        }));
      const updatedBanks = selectedBanks
        .filter((s) => s.status !== 2)
        .map((s) => ({
          id: s.id,
          name: s.label,
          status: s.status,
          type: s.type || "BANK",
          sid: s.sid,
        }));
      const updatedCrops = selectedCrops
        .filter((s) => s.status !== 2)
        .map((s) => ({
          cropId: s.cropId,
          cropName: s.cropName,
          cropUrl: s.cropUrl,
          id: s.id,
          marketId: 0,
        }));
      const obj = {
        address: {
          addressLine: address?.village,
          city: address?.district,
          dist: address?.village,
          latitude: addMarketDetails?.address?.latitude,
          longitude: addMarketDetails?.address?.longitude,
          marketId: "",
          pincode: address?.pincode,
          state: address?.state,
          traderId: 0,
          mid: addMarketDetails?.marketId,
        },
        adminId: adminId,
        apmcStatus: addMarketDetails?.apmcStatus,
        bankPartners: updatedBanks,
        caCount: addMarketDetails?.caCount,
        crops: updatedCrops,
        empCount: addMarketDetails?.empCount,
        headName: addMarketDetails?.headName,
        holidays: updatedHolidays,
        licenceType: addMarketDetails?.licenceType,
        maketKnownFor: addMarketDetails?.maketKnownFor,
        marketId: addMarketDetails?.marketId,
        marketImgs: images,
        marketName: addMarketDetails?.marketName,
        marketOpDays: addMarketDetails?.marketOpDays,
        marketOps: marketOps,
        marketOrs: addMarketDetails?.marketOrs,
        marketSize: addMarketDetails?.marketSize,
        marketType: addMarketDetails?.marketType,
        shopCount: Number(addMarketDetails?.shopCount),
        mid: addMarketDetails?.mid,
        noofBuyers: addMarketDetails?.noofBuyers,
        onoId: addMarketDetails?.employee?.onoId,
        peakHours: addMarketDetails?.peakHours,
        rmOrs: addMarketDetails?.rmOrs,
        softwares: updatedSoftwares,
        status: addMarketDetails?.status == "ACTIVE" ? 1 : 0,
        traderCount: addMarketDetails?.traderCount,
        transCount: addMarketDetails?.caCount,
        employee: {
          onoId: addMarketDetails?.onoId,
        },
      };

      handlePutCall({
        URL: "admin/markets/mpower",
        apiParams: obj,
      })
        .then(async ({ data, status }) => {
          toast.success(status.description);
          dispatch(setOpenMarketAddPanel(false));
          dispatch(setMarketAddEditVal("details"));

          await dispatch(setRefreshMarketByIdEntity());
          await dispatch(setRefreshAllMarketsEntity());
          // await dispatch(setMarketUpdated(true));

          // await dispatch(setRefreshAllMarketsEntity());
        })
        .catch((err: any) => {
          //   setLoading(false);
          // toast.error(err.response.data.status.description);
        });
    }
  };
  const validateAddEditMarket = () => {
    let hasValidationErrors = true;
    if (!addMarketDetails.marketName) {
      toast.error("Please enter Market name");
      hasValidationErrors = false;
    } else if (!addMarketDetails?.address?.longitude) {
      toast.error("Please enter Longitude");
      hasValidationErrors = false;
    } else if (!addMarketDetails?.address?.latitude) {
      toast.error("Please enter Latitude");
      hasValidationErrors = false;
    }
    // else if (!addMarketDetails.marketType) {
    //   toast.error("Please enter Market type");
    //   hasValidationErrors = false;
    // } else if (!addMarketDetails.licenceType) {
    //   toast.error("Please enter License type");
    //   hasValidationErrors = false;
    // }
    else if (!addMarketDetails.status) {
      toast.error("Please select Market status");
      hasValidationErrors = false;
    }
    // else if (!addMarketDetails.marketSize) {
    //   toast.error("Please enter Market size");
    //   hasValidationErrors = false;
    // }
    else if (!address?.pincode) {
      toast.error("Please enter pincode");
      hasValidationErrors = false;
    } else if (address?.pincode && address?.pincode.toString().length != 6) {
      toast.error("Please enter 6 digit pincode");
      hasValidationErrors = false;
    } else if (!address?.state) {
      toast.error("Please enter state");
      hasValidationErrors = false;
    } else if (!address?.district) {
      toast.error("Please enter District");
      hasValidationErrors = false;
    } else if (!address?.village) {
      toast.error("Please enter Village / Street");
      hasValidationErrors = false;
    }
    // else if (!addMarketDetails.apmcStatus) {
    //   toast.error("Please enter APMC status");
    //   hasValidationErrors = false;
    // } else if (!addMarketDetails.apmcStatus) {
    //   toast.error("Please enter APMC status");
    //   hasValidationErrors = false;
    // } else if (marketImages.length == 0) {
    //   toast.error("Please uplaod atleast one Mandi pictures");
    //   hasValidationErrors = false;
    // } else if (!addMarketDetails?.employee?.onoId) {
    //   toast.error("Please select Mandi head");
    //   hasValidationErrors = false;
    // } else if (!addMarketDetails?.rmOrs) {
    //   toast.error("Please enter RM Risk score");
    //   hasValidationErrors = false;
    // } else if (!addMarketDetails?.marketOrs) {
    //   toast.error("Please enter Mandi Risk score");
    //   hasValidationErrors = false;
    // }
    return hasValidationErrors;
  };
  return {
    handleLicenceDropdownChange,
    handleMarketStatusDropdownChange,
    martketStatusOptions,
    licenceTypeDropdownOptions,
    address,
    setAddress,
    otherSoftwareInput,
    setOtherSoftwareInput,
    softwares,
    setSoftwares,
    handleAddSoftware,
    handleRemoveSoftware,
    handleImportHolidaylist,
    handleChangeHoliday,
    handleDeleteHoliday,
    handleHolidaysAdd,
    holidays,
    marketDetailsEditStatus,
    employeeCountDropdownOptions,
    mandiEmployeesData,
    onUpdateAddMarketInput,
    addMarketDetails,
    handleEmpCountDropdownChange,
    onSaveMarketData,
    showCropModal,
    setShowCropModal,
    selectedCrops,
    addCropItem,
    softwareOptions,
    selectedSoftwares,
    setSelectedSoftwares,
    setMandiHeadDropdown,
    mandiHeadDropdown,
    bankOptions,
    selectedBanks,
    setSelectedBanks,
    onUploadImage,
    onRemoveImage,
    marketImages,
    schedules,
    setSchedules,
    activeDay,
    setActiveDay,
    handleAddAuction,
    handleDeleteAuction,
    handleSelectOption,
    revertAllDays,
    applyToAllDays,
    handleToggleDay,
    backupSchedules,
    onUpdateMarketData,
    removeCropItem,
    showRevert,
  };
};
export default useAddMarket;
